const Babel = require('@babel/standalone');

export default function preprocess(str) {
  const { code } = Babel.transform(str, { presets: ['env']} );
  return code;
}
